import React, { useEffect, useMemo, useState } from "react";
import {
  FaUsers,
  FaClock,
  FaTrain,
  FaChartPie,
  FaCalendarAlt,
} from "react-icons/fa";
import AnimatedDisplay from "../../CHARTS/AnimatedDisplay";
import { getDaysInFYMonths } from "../../Utilitie";

const KpiCard = ({ filteredData, data }) => {
  const [sumResult, setSumResult] = useState(null);

  useEffect(() => {
    if (data) {
      const temp = data?.sumData?.reduce((acc, curr) => {
        for (let key in curr) {
          if (typeof curr[key] === "number") {
            acc[key] = (acc[key] || 0) + curr[key];
          }
        }
        acc["month"] = curr.month;
        acc["year"] = curr.ut_year;
        return acc;
      }, {});
      setSumResult(temp);
    }
  }, [data]);

  const kpis = useMemo(() => {
    if (!filteredData || filteredData.length === 0) return {};

    const sum = (key) =>
      filteredData.reduce((a, b) => a + (Number(b[key]) || 0), 0);
    const avg = (key) =>
      (
        filteredData.reduce((a, b) => a + (Number(b[key]) || 0), 0) /
        filteredData.length
      ).toFixed(2);
    return {
      totalCrew: sum("No of Crew"),
      totalDutyHrs: sum("Total Duty Hrs"),
      totalTrips: sum("No of Trips"),
      avgUtilisation: avg("Utilisation %"),
      totalLeave:
        sum("Leave Days") +
        sum("Sick Leave Days") +
        sum("Absent Days") +
        sum("Other NonLeave Days"),
    };
  }, [filteredData]);
  let avgCrew = (
    sumResult?.ut_no_of_crew /
    [...data?.selectedFilters?.selectedLobby]?.length /
    [...data?.selectedFilters?.selectedMonth]?.length
  ).toFixed(0);
  let lengthOfMonth = [...data?.selectedFilters?.selectedMonth]?.length;
  const cards = [
    {
      label: "Avg Crew",
      value: avgCrew,
      icon: <FaUsers />,
      color: "#007bff",
    },
    {
      label: "Avg Duty Hours",
      value: (
        sumResult?.ut_total_duty_hrs /
        ([...data?.selectedFilters?.selectedLobby]?.length *
          avgCrew *
          lengthOfMonth)
      ).toFixed(0),
      icon: <FaClock />,
      color: "#17a2b8",
    },
    {
      label: "Avg Trips",
      value: (sumResult?.ut_no_of_trips / (lengthOfMonth * avgCrew)).toFixed(0),
      icon: <FaTrain />,
      color: "#28a745",
    },
    {
      label: "Avg Utilisation %",
      value: `${(
        (sumResult?.ut_total_duty_hrs /
          sumResult?.ut_no_of_crew /
          ((104 / 14) * 30)) *
        100
      ).toFixed(0)}%`,
      icon: <FaChartPie />,
      color: "#ffc107",
    },
    {
      label: "Avg Utilisation (Freight) %",
      value: `${(
        (sumResult?.ut_total_duty_hrs_fght /
          sumResult?.ut_no_of_crew /
          ((104 / 14) * 30)) *
        100
      ).toFixed(0)}%`,
      icon: <FaChartPie />,
      color: "#ff0707ff",
    },

    {
      label: "Avg Leave Days",
      value: (sumResult?.ut_leave_days / (lengthOfMonth * avgCrew)).toFixed(0),
      icon: <FaCalendarAlt />,
      color: "#dc3545",
    },
  ];

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
        gap: "16px",
        marginBottom: "30px",
      }}
    >
      {cards.map((card, index) => (
        <div
          className="newUiBody"
          key={index}
          style={{
            // background: "#fff",
            borderRadius: "14px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            padding: "18px 14px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
            transition: "transform 0.2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.03)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <div
            style={{
              fontSize: "30px",
              color: "#fff",
              backgroundColor: card.color,
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {card.icon}
          </div>
          <div style={{ lineHeight: 1.3 }}>
            <div style={{ fontSize: "14px", color: "#777" }}>{card.label}</div>
            <div
              style={{ fontSize: "20px", fontWeight: "bold", color: "#333" }}
            >
              {card.value && <AnimatedDisplay value={card.value || 0} />}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default KpiCard;
